import styled, { css } from "styled-components";
import { boxshadowMediumStyle } from "../../../../../../shared-components/lexus/styles/utils/Dropshadows.styles";

export const Button = styled.button`
    display: flex;
    position: relative;
    flex: 1 0 50%;
    flex-direction: column;
    align-items: flex-start;
    padding-inline: calc(var(--spacing-3) / 2);
    padding-block: var(--spacing-1);
    border: 0;
    border-radius: 4px;
    user-select: none;

    &[aria-pressed="true"] {
        color: var(--color-midnight);
        background-color: var(--color-white);
        ${boxshadowMediumStyle};
    }

    @supports not (padding-inline: 0) {
        padding-top: var(--spacing-1);
        padding-bottom: var(--spacing-1);
        padding-left: calc(var(--spacing-3) / 2);
        padding-right: calc(var(--spacing-3) / 2);
    }
`;

export const Wrapper = styled.div<{ enableMonthly: boolean }>`
    display: flex;
    flex-direction: row;
    padding: var(--spacing-1);
    background-color: var(--color-silver);
    border: 2px solid transparent;
    border-radius: 8px;

    ${({ enableMonthly }) =>
        !enableMonthly &&
        css`
            padding: calc(var(--spacing-1) / 2) 0 var(--spacing-1) 0;
            background-color: var(--color-white);
            border-color: var(--color-titanium);
            border-radius: 6px;

            ${Button} {
                padding-bottom: 0;
                box-shadow: none;
            }
        `};
`;

export const ButtonTitle = styled.span<{ isLoading?: boolean }>`
    /* Custom property to update font-size in UscCashPrice.styles  */
    --price-cash-font-size: 1.8rem;
    --price-cash-line-height: 2rem;
    --price-cash-color: ${({ isLoading }) => (isLoading ? "var(--color-platinum-dark)" : "var(--color-midnight)")};

    font-family: var(--font-regular);
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    line-height: 2rem;
    text-align: start;

    ${({ isLoading }) =>
        isLoading &&
        css`
            padding-inline-end: 20px;
            color: var(--color-platinum-dark);
        `};
`;

export const ButtonDescription = styled.span`
    margin-block-end: 6px;

    &,
    & > span {
        font-family: var(--font-book);
        font-size: 1.4rem;
        letter-spacing: 0.014rem;
        line-height: 2rem;
    }

    @supports not (margin-block: 0) {
        margin-bottom: 6px;
    }
`;

export const LoadingIconWrapper = styled.div`
    position: absolute;
    inset-block-end: 16px;
    inset-inline-end: 20px;
`;
